module Meevo.Plugins.BusinessInfo {
  "use strict";

  /**
  * Main Section of BusinessInfo 
  */
  export class MainSection extends Meevo.Components.CommonClasses.SettingsSectionBase {
      private zones: any;
      private context: BusinessInfoContext;
      private socialMediaItems: any[];

      constructor(sectionId: number,
          displayNameContentKey: string,
          template: string,
          isPrimarySection: boolean,
          handlesOwnCrud: boolean,
          baseEndpoint: string,
          sectionEndpoint: string,
          loggingService: Meevo.Components.Logging.ILoggingService,
          dataService: Meevo.Components.CommonClasses.ICommonDataService,
          noun: Meevo.Model.NounEnum = null,
          identityService: Components.Common.IIdentityService = null,
          context: BusinessInfoContext,
          modalService: Meevo.Components.Modal.IModalService,
          sectionSecurityKey?: string,
      ) {
          super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey);
          this.context = context;
      }
     
      /**
      * Handles retrieval of the item from the data service (if it hasn't already been loaded)
      * @returns {}
      */
      public activate(): void {
          this.bindFileGuid();
          this.isLoaded = true;
          this.zones = this.dataService.customMethodData('api/TimeZone/List', 'Post', { 'WithDetails': true });
          this.socialMediaItems = [];
          this.socialMediaItems.length = this.model.socialMediaSettings.socialMediaCount;
      }

      isStartEndTimeValid(item:any): void {

      var beginningTime = moment(item.startTime);
      var endTimecheck = moment(item.endTime);
      console.log(beginningTime.isBefore(endTimecheck));
          if (beginningTime.isBefore(endTimecheck)) {
              item.isTimeInValid = false;
          } else {
              item.isTimeInValid = true;
          }

      }
      bindFileGuid() {
          const businessModel = <Model.BusinessInfo>this.model;
          if (businessModel == undefined)
              return;
          else if (businessModel.fileGuid == undefined) {
              businessModel.fileGuid = NewGuid();
          }
          else if (!this.identityService.inCentralOfficeMode()
              && (businessModel.tenantFileGuid === businessModel.fileGuid)) {
              businessModel.fileGuid = NewGuid();
          }

          return;
          
      }

      preSave(): void {
          var busModel = <Model.BusinessInfo>this.model;
          _.forEach(busModel.businessHours, (item) => {
              if (item.isTimeInValid)
                  this.model.$setDirty();
                  return;
          });

          this.context.updateTextelSystemAutoReply();
          super.preSave();
      }

      showLocalRevertIndicator(ndx) {
          var value = this.model.socialMediaSettings['socialMediaValue_' + (ndx + 1)];
          value = value ? value : "";
          return this.showRevertIndicator('socialMediaValue_' + (ndx + 1), 'socialMediaSettings', value);
      }

      localRevertToParent(ndx) {
          return this.revertToParent('socialMediaValue_' + (ndx + 1), 'socialMediaSettings');
      }
  }
}